import { useFlags } from "launchdarkly-react-client-sdk"
import { useState } from "react"
import { useLocation, useParams } from "react-router"
import { useSearchParams } from "../../hooks/useSearchParams"
import { LOCATION_IDS_WITH_STALE_DATA, ROUTES } from "../../utils/constants"
import { getLocationId } from "../../utils/helpers"
import { useGetAsset } from "../WatchedLocations/hooks/useAssetService"
import { Banner } from "./Banner"

export const StaleDataBanner: React.FC = () => {
  const location = useLocation()
  const { showStaleDataBanner } = useFlags()
  const [dismissedLocationId, setDismissedLocationId] = useState<string | null>(
    null
  )
  const { assetId } = useParams<{ assetId: string }>()
  const { id: locationId } = useSearchParams() // needed for location-details page
  const { data } = useGetAsset(assetId)
  const selectedLocationId = getLocationId(data?.asset) || locationId || ""
  const isLocationWithStaleData = LOCATION_IDS_WITH_STALE_DATA.some(id =>
    selectedLocationId.startsWith(id)
  )
  const isAssetOrLocationDetailsPage =
    location.pathname.includes(ROUTES.LOCATION_DETAILS) ||
    location.pathname.includes(ROUTES.ASSETS)

  const showBanner =
    isLocationWithStaleData &&
    isAssetOrLocationDetailsPage &&
    dismissedLocationId !== selectedLocationId

  if (
    !showStaleDataBanner ||
    !isAssetOrLocationDetailsPage ||
    !selectedLocationId.length
  ) {
    return null
  }

  return (
    <Banner
      type="warning"
      open={showBanner}
      dismissFunction={() => setDismissedLocationId(selectedLocationId)}
    >
      This country has not reported any influenza testing data in the past 28
      days. Typically, this is an indication of low flu activity in the country,
      though it may be the result of unexpected non-reporting.
    </Banner>
  )
}
